import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Project,
  ProjectResource,
  ResourcesListingFilter,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  projectResources: Identifiable<ProjectResource>[];
  filter: ResourcesListingFilter;
  totalPages: number;
  retrieveProjectResourcesListing(
    request: Boundaries["retrieveProjectResourcesListing"]["request"],
  ): void;
}

function useRetrieveProjectResourcesListing(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectResourcesListingRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectResourcesListingRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectResourcesListingRequestFailure(project),
    ),
    projectResources: useSelector(() =>
      selector.getProjectResourcesListing(project),
    ),
    filter: useSelector(selector.getProjectResourcesListingFilter),
    totalPages: useSelector(() =>
      selector.getProjectResourcesListingTotalPages(project),
    ),
    retrieveProjectResourcesListing: core.retrieveProjectResourcesListing,
  };
}

export { useRetrieveProjectResourcesListing };
